import React, { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import AuthSync from "./AuthSync";
import { getCurrentUserRole } from "../utils/roleUtils";
import NotFoundRedirect from "./NotFoundRedirect";

const ProtectedRoute = ({ roles, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const authStatus = localStorage.getItem("token") ? true : false;
  const currentRole = getCurrentUserRole();
  const navigate = useNavigate();
  const location = useLocation(); 

  useEffect(() => {
    if (!authStatus) {
      navigate("/");
    }
  }, [authStatus, navigate]);

  // Remove the redirect logic - let NotFoundRedirect handle it

  if (authStatus && typeof roles !== "undefined" && (!currentRole || !roles.includes(currentRole))) {
    return <NotFoundRedirect />;
  }

  return authStatus ? (
    <>
      <AuthSync />
      <div className="flex h-screen overflow-y-auto bg-blue-75">
        {/* Sidebar */}
        <Sidebar 
          isOpen={isOpen} 
          setIsOpen={setIsOpen} 
          isMobileSidebarOpen={isMobileSidebarOpen}
          setIsMobileSidebarOpen={setIsMobileSidebarOpen}
        />

        <div
          className={`flex flex-col flex-grow w-full transition-all duration-300 pl-0 ${
            isOpen ? "md:pl-[250px] 2xl:pl-[300px]" : "md:pl-[80px] 2xl:pl-[100px]"
          }`}
        >
          {/* Header */}
          <Header 
            isMobileSidebarOpen={isMobileSidebarOpen}
            setIsMobileSidebarOpen={setIsMobileSidebarOpen}
          />
          {/* Page Content */}
          <div className={`2xl:p-6 p-4 main-container-bg ${location.pathname === "/generate-training" || location.pathname === "/plan-optimizer" ? "2xl:!p-0 !p-0" : ""}`}>{children}</div>
        </div>
      </div>
    </>
  ) : null;
};

export default ProtectedRoute;
